module.exports = __webpack_public_path__ + "static/media/avis_logo.99dee60b.svg";